import React from "react";
import { mdiClockOutline, mdiFilterOutline, mdiRadioboxMarked } from "@mdi/js";
import AppSwitch from "../../../components/layout/app/AppSwitch";
import { actionLines, conditionLines, triggerText } from "../../../automation/format";
import { TYPE_LOOK } from "../../../automation/look";
import { SummaryLine } from "../AutomationDetail";
import { NOTIFY_TYPES } from "./draft";
import { Card, Hint } from "./controls";

const NotifyRow = ({ label, value, onChange }) => (
  <div className="hx-auto-step-row">
    <span className="hx-auto-notify-label">{label}</span>
    <AppSwitch checked={value} onChange={onChange} label={label} />
  </div>
);

// Last step: its name, and a summary of what was picked (preview is what the
// API will be sent). Automations that run on their own can notify the person
// who sets this: when a run fails, or every time it runs
// (app/screens/Automation/create/SaveStep.js).
export default function SaveStep({ draft, preview, onName, onNotify, lookup, me }) {
  const look = TYPE_LOOK[draft.type] || TYPE_LOOK.tap;
  const conditions = conditionLines(preview, lookup);
  const actions = actionLines(preview, lookup);
  return (
    <>
      <Card>
        <label className="hx-auto-step-label" htmlFor="hx-auto-name">
          Automation name
        </label>
        <input
          id="hx-auto-name"
          className="hx-input"
          value={draft.name}
          onChange={(event) => onName(event.target.value)}
          maxLength={60}
          placeholder="e.g. Weekday mornings"
          autoComplete="off"
        />
        <Hint className="is-primary">You can rename it later.</Hint>
      </Card>
      <section className="hx-auto-summary" style={{ "--hx-auto-card": look.color }} aria-label="What it does">
        <SummaryLine icon={mdiClockOutline} label="When" lines={[triggerText(preview, lookup)]} />
        {conditions.length ? <SummaryLine icon={mdiFilterOutline} label="Only if" lines={conditions} /> : null}
        {actions.length ? <SummaryLine icon={mdiRadioboxMarked} label="Then" lines={actions} /> : null}
      </section>
      {NOTIFY_TYPES.includes(draft.type) ? (
        <Card className="hx-auto-notify">
          <NotifyRow label="Notify me if it fails" value={draft.notify !== "off"} onChange={(on) => onNotify(on ? "failures" : "off")} />
          <NotifyRow
            label="Notify me each time it runs"
            value={draft.notify === "always"}
            onChange={(on) => onNotify(on ? "always" : "failures")}
          />
          {draft.notifyTo && draft.notifyTo !== me && !draft.notifyChanged ? (
            <Hint>Notifications go to {draft.notifyTo}. Changing these sends them to you.</Hint>
          ) : null}
        </Card>
      ) : null}
    </>
  );
}
